import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import compose from 'utils/compose';
import { getPayeeDisplayText } from 'utils/utils';
import { DateTime } from 'luxon';

import { transactionsUtils } from 'companion-app-components/flux/transactions';
import { isBankOwnedPending } from 'data/transactions/utils';

import AmountField from 'components/QuickenControls/AmountField';
import CategoryField from 'components/QuickenControls/CategoryField';
import QCurrency from 'components/QCurrency';

import { withStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import HourglassEmptyRounded from '@mui/icons-material/HourglassEmptyRounded';

import { H1, H2 } from './styles';

export const styles = (theme) => {
  const ellipseStyle = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  };
  return ({
    typeContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      height: 50,
    },
    catAndDate: {
      fontWeight: 50,
    },
    ellipseStyle,
    payeeField: {
      ...ellipseStyle,
      whiteSpace: 'nowrap',
      width: '100%',
      color: theme.palette.text.primary,
      fontWeight: 500,
    },
    dateField: {
      whiteSpace: 'nowrap',
      width: '100%',
      color: theme.palette.text.secondary,
      float: 'left',
      fontWeight: 500,
    },
    categoryField: {
      ...ellipseStyle,
      color: theme.palette.text.secondary,
      float: 'right',
      width: '100%',
      paddingLeft: 30,
    },
    amountField: {
      ...ellipseStyle,
      width: '100%',
      fontWeight: 500,
      color: theme.palette.text.strong,
    },
    bankPending: {
      marginLeft: 5,
    },
  });
};

class TransactionRow extends PureComponent {

  static propTypes = {
    txn: PropTypes.any,
    classes: PropTypes.object,

    // QCurrency
    getTxnCurrency: PropTypes.func,
  };

  renderCatField = (txn) => {

    const isSplit = transactionsUtils.isSplitTxn(txn);
    if (!isSplit) {
      return (
        <CategoryField
          editable={false}
          clickable={false}
          value={txn.coa}
          autoFocus={false}
          variant="caption"
          name="category"
          classNameWhenNotEditable={this.props.classes.categoryField}
          txn={txn}
        />
      );
    }
    return (
      <Typography className={this.props.classes.categoryField} variant="caption" name="category">
        --- Split ---
      </Typography>
    );
  };

  render() {
    const { txn, classes } = this.props;
    return (
      <div style={{ width: '100%' }}>
        {txn &&
          <div>
            <Grid container spacing={1}>
              <Grid item xs={4} className={classes.typeContainer}>
                <Typography className={classes.payeeField} variant="caption" name="payee">
                  {getPayeeDisplayText(txn.payee)}
                  {isBankOwnedPending(txn) && <HourglassEmptyRounded fontSize="inherit" className={classes.bankPending} />}
                </Typography>
              </Grid>
              <Grid item xs={2} className={classes.typeContainer}>
                <Typography className={classes.dateField} variant="caption" name="date">
                  {DateTime.fromISO(txn.postedOn).toFormat('MM/dd/yyyy')}
                </Typography>
              </Grid>
              <Grid item xs={3} className={classes.typeContainer}>
                <H2>{this.renderCatField(txn)}</H2>
              </Grid>
              <Grid item xs={3} className={classes.typeContainer}>
                <H1 style={{ textAlign: 'right' }}>
                  <AmountField
                    value={String(Math.abs(txn.amount))}
                    className={this.props.classes.amountField}
                    currencySymbol={this.props.getTxnCurrency(txn.accountId)}
                    variant="caption"
                    name="amount"
                  />
                </H1>
              </Grid>
            </Grid>
          </div>}
      </div>
    );
  }

}

export default compose(
  QCurrency(),
)(withStyles(TransactionRow, styles));

